import { Link } from "react-router-dom";
import Layout from "../../components/Layout";
import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Plus, Building2 } from "lucide-react";
import { Button } from "../../components/ui/button";
import { SELLER_STAGES } from "../../lib/stages";
import { t } from "../../lib/i18n";

export default function SellerCompanies() {
  const [companies, setCompanies] = useState([]);
  useEffect(() => {
    (async () => {
      const r = await api.get("/companies/mine");
      setCompanies(r.data || []);
    })();
  }, []);
  return (
    <Layout>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12 space-y-10">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="font-mono-label text-gold">{t("Vendedor")}</span>
            <h1 className="font-serif-display text-4xl md:text-5xl mt-3">{t("Mis empresas")}</h1>
          </div>
          <Link to="/seller/companies/new">
            <Button
              className="rounded-none bg-[#1E3A5F] hover:bg-[#2B4C78] text-bone h-11 px-6"
              data-testid="companies-add-btn"
            >
              <Plus className="w-4 h-4 mr-2" />{" "}{t("Añadir empresa")}
            </Button>
          </Link>
        </div>
        {companies.length === 0 ? (
          <div className="hairline p-12 text-center bg-card">
            <Building2 className="w-10 h-10 mx-auto text-muted-foreground mb-4" />
            <p className="text-muted-foreground">{t("No tienes ninguna empresa todavía.")}</p>
          </div>
        ) : (
          <div className="hairline">
            {companies.map((co, i) => {
              const stage = SELLER_STAGES.find((s) => s.id === co.stage) || SELLER_STAGES[0];
              const completed = co.completed_stages?.length || 0;
              return (
                <Link
                  key={co.company_id}
                  to={`/seller/company/${co.company_id}`}
                  className={`grid grid-cols-12 gap-4 px-6 py-5 bg-card hover:bg-bone ${i > 0 ? "hairline-t" : ""}`}
                  data-testid={`companies-row-${co.company_id}`}
                >
                  <div className="col-span-12 md:col-span-4">
                    <div className="font-mono-label text-gold">{co.sector}</div>
                    <div className="font-serif-display text-xl">{co.name}</div>
                  </div>
                  <div className="col-span-6 md:col-span-3">
                    <div className="font-mono-label text-muted-foreground">{t("País")}</div>
                    <div>{co.country}</div>
                  </div>
                  <div className="col-span-6 md:col-span-3">
                    <div className="font-mono-label text-muted-foreground">{t("Etapa actual")}</div>
                    <div>{stage.name} ({completed}/{SELLER_STAGES.length})</div>
                  </div>
                  <div className="col-span-12 md:col-span-2 text-right">
                    {co.qualified ? (
                      <span className="font-mono-label bg-forest/10 text-forest border border-forest/30 px-2 py-1">{t("Cualificada")}</span>
                    ) : (
                      <span className="font-mono-label bg-secondary px-2 py-1">{t("En desarrollo")}</span>
                    )}
                  </div>
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </Layout>
  );
}
